import { joinClassNames } from '../../utils';
import { LoadingSpinnerSize, LoadingSpinnerTheme } from './enums';
import styles from './styles.module.scss';

type LoadingSpinnerProps = {
  center?: boolean;
  size?: LoadingSpinnerSize;
  theme?: LoadingSpinnerTheme;
};

export const LoadingSpinner = ({
  center = true,
  size = LoadingSpinnerSize.Tiny,
  theme = LoadingSpinnerTheme.Light,
}: LoadingSpinnerProps) => (
  <div className={center ? styles.loadingSpinnerContainer : styles.inline}>
    <div
      role="status"
      aria-label="Loading"
      className={joinClassNames(styles.loadingSpinner, styles[size], styles[theme])}
    />
  </div>
);

LoadingSpinner.displayName = 'LoadingSpinner';
